import React from "react";
import CardListAnimation from "./cardLists/CardListAnimation";

function SkinAnimationContent () {
  return(
    
    <section className="one-agent-info-container">
      <section className="one-agent-top-container">
        <section className="full-portrait-container">
        <hr/>
        <h1>Animation</h1>
        <CardListAnimation />
        </section>
      </section>

    
     </section>    
  )
}

export default SkinAnimationContent;